import type {BrandColor} from '@Components/mystuff-brands/brand-kits.types';
import {useAppSelector} from '@/hooks';

export const useBrandColorsMap = (): Record<string, BrandColor> => {
  return useAppSelector(({brands}) => {
    return brands.colors;
  });
};
